<template>
  <div class="login-box">
    <div class="left-box">
      <Carousel
        autoplay
        v-model="carouselIndex"
        loop
        arrow="never"
        radius-dot
        :autoplay-speed="3000"
      >
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_aidprint">
            <div class="car-item">
              <img class="img" src="../../assets/ic_aidprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner1.png"
                />
                通用基础版
              </div>
              <div class="des">满足全场景自助共享文印的全能型选手</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_custprint">
            <div class="car-item">
              <img class="img" src="../../assets/ic_custprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner2.png"
                />
                服务窗口版
              </div>
              <div class="des">用心为特定场景和使用人群而打造</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_ops">
            <div class="car-item">
              <img class="img" src="../../assets/ic_product_ops.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/ic_banner3.png"
                />
                智能运维
              </div>
              <div class="des">设备远程运维管理和服务流程的好帮手</div>
            </div>
          </a>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="login-content">
      <a href="https://www.aidprint.com" target="_blank">
        <img src="../../assets/logo.png" alt class="logo" />
      </a>
       <div class="switch-lang">
        <switch-lang></switch-lang>
      </div>
      <!-- 短信验证码登录 -->
      <div class="login-box-from">
        <div class="head-box">
          <span class="login-title">{{words.RetrievePassword}}</span>
          <img
            :src="closeBtn"
            alt="关闭"
            class="closeBtn"
            @click="$lfy.Jump.Back()"
          />
        </div>
        <div class="from-box">
          <div class="item">
            <input
              type="text"
              :placeholder="words.Pleaseenterthephonenumber2"
              class="input"
              v-model="info.tel"
              @focus="accountFocus = true"
              @blur="accountFocus = false"
            />
            <div class="icon-box" :class="{ 'icon-box-f': accountFocus }">
              <img
                :src="accountFocus ? accountImg2 : accountImg"
                class="icon"
              />
            </div>
          </div>
          <div class="item">
            <input
              type="text"
              class="input"
              maxlength="6"
              :placeholder="words.SmsCode"
              v-model="info.code"
              @focus="pwdFocus = true"
              @blur="pwdFocus = false"
            />
            <div class="icon-box" :class="{ 'icon-box-f': pwdFocus }">
              <img :src="pwdFocus ? pwdImg2 : pwdImg" class="icon" />
            </div>
            <span
              class="get-code-btn"
              @click="getMobileCode"
              v-if="!SmsCodeData.status"
            >
              {{ words.getverificationcode }}
            </span>
            <span class="get-code-btn" v-else>{{ SmsCodeData.num }}S</span>
          </div>
          <div class="login-btn" @click="JumpSetPassword">
            {{ words.Next }}
          </div>
          <div class="tips">{{words.retrievePwdTips}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loginMenu from "../../components/login-mode";
import switchLang from "../../components/switch-lang";
export default {
  components: { loginMenu,switchLang},
  data() {
    return {
      background: require("../../assets/login_bg.png"),
      closeBtn: require("../../assets/close.png"),
      Logo: require("../../assets/logo-black.png"),
      AppCode: require("../../assets/app_code.png"),
      info: {
        tel: "",
        code: "",
      },
      SmsCodeData: {
        status: false,
        num: 60,
      },
      setInterval: false,
      accountImg: require("../../assets/ic_login_account.png"),
      accountImg2: require("../../assets/ic_login_account_t.png"),
      pwdImg: require("../../assets/ic_login_pwd.png"),
      pwdImg2: require("../../assets/ic_login_pwd_t.png"),
      eyeImg: require("../../assets/ic_login_eye.png"),
      eyeImg2: require("../../assets/ic_login_eye_c.png"),
      accountFocus: false,
      pwdFocus: false,
      pwdText: false,
      carouselIndex:0,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["GetCode"]),
    getMobileCode() {
      let params = {
        tel: this.info.tel,
        mode: 1,
      };
      if (!params.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(params.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if (this.SmsCodeData.status) return false;
      this.SmsCodeData.status = true;
      this.GetCode(params).then((res) => {
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          this.SmsCodeData.status = false;
          return false;
        }
        this.setInterval = setInterval(() => {
          this.SmsCodeData.num--;
          if (this.SmsCodeData.num < 1) {
            clearInterval(this.setInterval);
            this.setInterval = {};
            this.SmsCodeData = {
              num: 60,
              status: false,
            };
          }
        }, 1000);
      });
    },
    JumpSetPassword() {
      if (!this.info.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(this.info.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if (!this.info.code) {
        this.$Message.error("请输入验证码");
        return false;
      }
      this.$lfy.Jump.open("pass-reset", this.info);
      /* this.$router.push({
        name: "pass-reset",
        params: this.info
      }); */
    },
  },
  computed: mapGetters({
    words: "words",
    user: "user",
  }),
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>